import React from 'react';

import PropTypes from 'prop-types';

import styles from './PageTitle.scss';

function PageTitle(props) {
    const {
        children,
        className = '',
        ...otherProps
    } = props;

    return (
        <h1
            className={`${styles.pageTitle} ${className}`}
            {...otherProps}
        >
            {children}
        </h1>
    );
}

PageTitle.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default PageTitle;
